import React from 'react';
import {connect} from "react-redux";

import User from './User';
import CreateUserModal from "./CreateUserModal";

import {
    fetchUsers,
    changePassword,
    createNewUser
} from "./reducer";

export class UserManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            userModalVisible: false
        };

        this.showUserModal = this.showUserModal.bind(this);
        this.hideUserModal = this.hideUserModal.bind(this);
        this.createNewUser = this.createNewUser.bind(this);
    }

    showUserModal() {
        this.setState({userModalVisible: true});
    }

    hideUserModal() {
        this.setState({userModalVisible: false});
    }

    createNewUser(user) {
        this.props.createNewUser(user);
        this.hideUserModal();
    }

    componentDidMount() {
        this.props.fetchUsers();
    }

    render() {
        return (
            <div className="animated fadeIn">
                <CreateUserModal visible={this.state.userModalVisible}
                                 onSubmit={this.createNewUser}
                                 onCancel={this.hideUserModal}/>
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Benutzer</h4>
                        <div className="row">
                            <div className="col-lg-12">
                                <button type="button" className="btn btn-light pull-right"
                                        onClick={this.showUserModal}>
                                    <i className="fa fa-plus-circle"/>&nbsp;neuer Benutzer
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Benutzername</th>
                                        <th>Rolle</th>
                                        <th>Passwort</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.users.map((user) => <User {...user} key={user.username}
                                                                          changePassword={this.props.changePassword}/>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        users: state.user.get('users').toJS()
    };
}

const ConnectedUserManager = connect(mapStateToProps, {fetchUsers, changePassword, createNewUser})(UserManager);

export default ConnectedUserManager;



// WEBPACK FOOTER //
// ./src/admin/user/UserManager.js